// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 10-security-compliance.md

/**
 * Merge a single-field role-group value (the wizard / Settings → Identity inputs
 * expose one group per role) with any additional groups already configured for
 * that role. A role can hold several groups when configured through the Users
 * role-mapping matrix; the single field edits only the first, so the extras must
 * be carried through a same-provider re-save — otherwise the save silently drops
 * them, which for `user` (the sign-in restriction) would widen who can sign in.
 *
 * The field is hydrated from `preserved[0]`, so an untouched re-save round-trips
 * the whole array; editing replaces the first entry and keeps the rest; clearing
 * the field keeps the extras rather than removing the restriction. Duplicates
 * are collapsed (the matrix rejects duplicate (id, role) pairs).
 */
export function mergeRoleGroup(
  fieldValue: string,
  preserved: readonly string[] | undefined,
): string[] {
  const extras = (preserved ?? []).slice(1);
  const first = fieldValue.trim();
  return [...new Set(first ? [first, ...extras] : extras)];
}
